import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getCoupons = createAsyncThunk('coupons/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/coupon/get-all-coupon`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addCoupons = createAsyncThunk('coupons/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/coupon/create-coupon`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteCoupons = createAsyncThunk('coupons/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/coupon/delete-coupon/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editCoupons = createAsyncThunk('coupons/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/coupon/update-coupon/${data?.id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allCouponsInfo: [],
  error: null
}

const couponsSlice = createSlice({
  name: 'coupons',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCoupons.fulfilled, (state, action) => {
        state.isLoading = false
        state.allCouponsInfo = action.payload?.data?.data
      })
      .addCase(getCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addCoupons.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteCoupons.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editCoupons.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editCoupons.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editCoupons.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default couponsSlice.reducer
